<script setup>
import { ref, onMounted } from 'vue'
import PrimaryButton from '@/Shared/Components/Buttons/PrimaryButton.vue'
import AutoComplete from '@/Public/Partials/ExploreBusOption/AutoComplete.vue'

const props = defineProps({
  canSearchOnMount: Boolean,
})

const autocomplete = ref(null)

onMounted(() => {
  if (autocomplete.value && props.canSearchOnMount.value) {
    onSearch()
  }
})

const params = {
  lat: null,
  lng: null,
  type: null,
  day: null,
  route_id: null,
}

const onSearch = () => {
  params.type = autocomplete.value.type
  params.day = 'monday'

  if (params.type != 'route') {
    params.lat = autocomplete.value.lat
    params.lng = autocomplete.value.lng
  } else {
    params.route_id = autocomplete.value.id
  }

  window.location.href = route('bus.map.show', params)
}
</script>

<template>
  <div class="md:flex py-4">
    <div class="flex flex-col sm:flex-row outline-none md:w-3/4">
      <div class="flex items-center grow md:mb-4 lg:mb-0 sm:mr-4">
        <div class="relative w-full">
          <AutoComplete v-model="autocomplete" />
        </div>
      </div>
      <div class="sm:flex">
        <div class="mt-2 sm:mt-0">
          <PrimaryButton
            class="w-full px-12 justify-center"
            @click="onSearch"
          >
            Search
          </PrimaryButton>
        </div>
      </div>
    </div>
  </div>
</template>
